/* Portal para o <body> que preserva o escopo de CSS do painel.

   Por que existe
   --------------
   Todo o CSS desta feature é escopado em `.ie-root` (ver decisão D1 do plano),
   para não vazar o preflight do Tailwind sobre o Bootstrap/CoreUI da
   plataforma. A consequência é que qualquer coisa renderizada FORA desse
   wrapper fica sem estilo algum.

   Portais são exatamente esse caso: `createPortal(..., document.body)` põe o
   conteúdo como irmão do wrapper, não dentro dele. No projeto de origem isso
   não importava, porque lá o Tailwind era global.

   Por que usar portal, e não renderizar no lugar
   ----------------------------------------------
   Elementos flutuantes (drawer, popover, dropdown) usam `position: fixed`. Mas
   `fixed` se ancora no viewport apenas se nenhum ancestral criar containing
   block — e os Cards do painel têm `backdrop-filter` e `transform` (animação de
   entrada), que criam. Sem o portal, o elemento fica preso dentro do card: não
   cobre a tela, não rola direito, e o overlay não intercepta cliques (eles
   "atravessam" para o conteúdo por baixo).

   Faixa de z-index dentro do AVA
   ------------------------------
     1017–1032  sidebar, header, footer, breadcrumb do AVA
     1034–1039  ESTE painel (acima do layout, abaixo dos modais)
     1040       .modal-backdrop do Bootstrap
     1050       .modal
     1060–1070  popover / tooltip
   Um modal da plataforma deve aparecer ACIMA do que este painel abre. */

import React from "react";

import PropTypes from "prop-types";
import { createPortal } from "react-dom";

export default function PortalIE({ children }) {
  return createPortal(<div className="ie-root">{children}</div>, document.body);
}

PortalIE.propTypes = {
  children: PropTypes.node
};

PortalIE.defaultProps = {
  children: null
};
